"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _vinRecallLookup = _interopRequireDefault(require("./vin-recall-lookup.css"));
var isStringTruncated = function isStringTruncated(str, num) {
  return str && str.length > num;
};
var truncateString = function truncateString(str, num) {
  if (str && str.length > num) {
    return str.slice(0, num).trim() + "...";
  }
  return str;
};
var VinRecallItem = function VinRecallItem(_ref) {
  var label = _ref.label,
    value = _ref.value,
    theme = _ref.theme,
    readMore = _ref.readMore,
    handleReadMoreEvent = _ref.handleReadMoreEvent;
  if (readMore) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: theme.row + " " + _vinRecallLookup["default"].resultDataWrapperRow
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: theme['col-xs-12'] + " " + theme['col-sm-5']
    }, /*#__PURE__*/_react["default"].createElement("p", {
      className: "" + theme.bodyCopy
    }, label)), /*#__PURE__*/_react["default"].createElement("div", {
      className: theme['col-xs-12'] + " " + theme['col-sm-7']
    }, /*#__PURE__*/_react["default"].createElement("p", {
      className: theme.bodyCopy + " " + _vinRecallLookup["default"].resultDataDetail
    }, truncateString(value, 60)), isStringTruncated(value, 60) && /*#__PURE__*/_react["default"].createElement("button", {
      type: "button",
      className: _vinRecallLookup["default"].resultDataReadMore + " " + theme.labelBig,
      onClick: function onClick() {
        handleReadMoreEvent(value, label);
      }
    }, readMore)));
  }
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: theme.row + " " + _vinRecallLookup["default"].resultDataWrapperRow
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: theme['col-xs-8'] + " " + theme['col-sm-5']
  }, /*#__PURE__*/_react["default"].createElement("p", {
    className: "" + theme.bodyCopy
  }, label)), /*#__PURE__*/_react["default"].createElement("div", {
    className: theme['col-xs-4'] + " " + theme['col-sm-7']
  }, /*#__PURE__*/_react["default"].createElement("p", {
    className: "" + theme.bodyCopy
  }, value)));
};
var _default = VinRecallItem;
exports["default"] = _default;